import { createHostModule } from '@wix/sdk-runtime/host-modules';
export const queryParamsRuntime = createHostModule({
    add: ({ channel }) => function add(...args) {
        return channel.invoke({
            namespace: 'location',
            method: 'queryParams.add',
            args,
        });
    },
    remove: ({ channel }) => function remove(...args) {
        return channel.invoke({
            namespace: 'location',
            method: 'queryParams.remove',
            args,
        });
    },
});
//# sourceMappingURL=queryParams.runtime.js.map